module.exports = __webpack_public_path__ + "assets/caret.742f1c06.svg";